var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mkt-module"},[_c(_vm.component,{ref:"component",tag:"component"}),_c('nav-bar',{ref:"navbar",attrs:{"step":_vm.component},on:{"changeComponent":(c) => _vm.component = c.id}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }